class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.hideDuplicateRecommendations();

    this.duplicateRecommendationsObserver = new MutationObserver(() => {
      this.hideDuplicateRecommendations();
    });

    this.duplicateRecommendationsObserver.observe(this, {
      childList: true,
      subtree: true,
    });
  }

  disconnectedCallback() {
    if (this.duplicateRecommendationsObserver) {
      this.duplicateRecommendationsObserver.disconnect();
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-items',
        section: 'cart-items',
        selector: '.js-cart-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'cart-footer',
        section: 'cart-footer',
        selector: '.js-cart-footer-contents'
      },
      {
        id: 'cart-drawer-icon-bubble',
        section: 'cart-drawer-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  hideDuplicateRecommendations() {
    const cartProductHandles = Array.from(this.querySelectorAll('.cart-item__title[href*="/products/"]'))
      .map((link) => this.getProductHandleFromUrl(link.getAttribute('href')))
      .filter(Boolean);

    if (!cartProductHandles.length) return;

    const cartProductHandleSet = new Set(cartProductHandles);
    const cartContainsMembership = cartProductHandleSet.has('the-wildside');

    this.querySelectorAll('.drawer__recommendations .product-card-mini__item').forEach((item) => {
      const productLink = item.querySelector('a[href*="/products/"]');
      const productHandle = productLink && this.getProductHandleFromUrl(productLink.getAttribute('href'));

      if (!productHandle) return;

      if (cartProductHandleSet.has(productHandle) || (cartContainsMembership && productHandle === 'the-wildside')) {
        item.remove();
      }
    });

    const recommendations = this.querySelector('.drawer__recommendations');
    if (recommendations && !recommendations.querySelector('.product-card-mini__item')) {
      recommendations.remove();
    }
  }

  getProductHandleFromUrl(url) {
    if (!url) return '';

    try {
      const parsedUrl = new URL(url, window.location.origin);
      const match = parsedUrl.pathname.match(/\/products\/([^/?#]+)/);
      return match ? match[1] : '';
    } catch (error) {
      return '';
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);